import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import type { ContentDropoffBucket } from '@/types/content';

// SPEC-021: 10-decile drop-off histogram. Each bar shows how many distinct
// users reached that decile of progress. A healthy article curve slopes
// down; a cliff between the first two buckets means readers bounce fast.

interface ContentDropoffChartProps {
  data: ContentDropoffBucket[];
}

const chartConfig: ChartConfig = {
  count: {
    label: 'Readers',
    theme: { light: 'var(--chart-2)', dark: 'var(--chart-2)' },
  },
};

export function ContentDropoffChart({ data }: ContentDropoffChartProps) {
  const points = data.map((b) => ({
    ...b,
    label: `${b.decile * 10}%`,
  }));

  return (
    <ChartContainer config={chartConfig} className="h-[240px] w-full">
      <BarChart data={points} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis
          dataKey="label"
          tickLine={false}
          axisLine={false}
          fontSize={11}
        />
        <YAxis
          tickLine={false}
          axisLine={false}
          fontSize={11}
          allowDecimals={false}
        />
        <ChartTooltip content={<ChartTooltipContent indicator="dashed" />} />
        <Bar dataKey="count" fill="var(--color-count)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ChartContainer>
  );
}
